import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import MenuItem from '@mui/material/MenuItem';
import { useLocation, useNavigate } from 'react-router-dom';
import { InputLabel, Select } from '@mui/material';
import { useCreateAdsMutation } from 'App/services/adsServiceApi';
import { useGetAllProviderQuery } from 'App/services/providerServiceApi';
import { toast } from 'react-toastify';


const adNames = ["App open", "interstitial", "Native small", "Native medium", "rewarded", "rewarded interstitial"];

export default function AdsFormDialogue() {

  const location = useLocation();
  const data = location.state || {};
  // const id = data.data
  const [open, setOpen] = React.useState(false);
  const [adsName, setAdsName] = React.useState('');
  const [adsContent, setAdsContent] = React.useState('');
  const [providerId, setProviderId] = React.useState(data.data);
  const navigate = useNavigate();


  // console.log("sub ==> ", data)
  const { data: ads, error: adsError, isLoading: adsLoading } = useGetAllProviderQuery();
  const [createAds, { isLoading, isError, error }] = useCreateAdsMutation();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddAds = async (event) => {
    event.preventDefault();
    try {
     
      if (adsName && adsContent) {
        await createAds({ adName: adsName, content: adsContent, providerId }).unwrap();
        toast.success("Adds Successfully Created!!");
        handleClose();
        setAdsName('');
        setAdsContent('');
      }

      else {
        toast.error("Adds all Field Fill")
      }


    } catch (error) {
      toast.error(error.data.error)
    }
  };




  return (
    <React.Fragment>
      <Button variant="contained" color="light" onClick={handleClickOpen}>
        Add Ads
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: handleAddAds,
        }}
      >
        <DialogTitle>Add Ads</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the name and select the Provider for the Ads:
          </DialogContentText>

          <Select
            fullWidth
            sx={{ height: 40 }}
            value={adsName}

            onChange={(e) => setAdsName(e.target.value)}
          >
            {adNames.map((name) => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}

          </Select>
          <TextField
            autoFocus
            // required
            margin="dense"
            id="content"
            name="content"
            label="Content"
            type="text"

            fullWidth
            value={adsContent}
            onChange={(e) => setAdsContent(e.target.value)}
            error={!!error}
          />


          <Select
            required
            labelId="category-label"
            label="Provider Name"
            fullWidth
            value={providerId}
            sx={{ height: 40 }}
            onChange={(e) => setProviderId(e.target.value)}
            displayEmpty
            disabled
          >
            <MenuItem value="" disabled>Select Provider</MenuItem>
            {adsLoading ? (
              <MenuItem disabled>Loading...</MenuItem>
            ) : adsError ? (
              <MenuItem disabled>Error loading Provider</MenuItem>
            ) : (
              ads.map((ads) => (
                <MenuItem key={ads.id} value={ads.id}>
                  {ads.name}
                </MenuItem>
              ))
            )}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" disabled={isLoading} name="submit">
            Add {isLoading && 'Loading...'}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
